import React, { useRef } from 'react';
import Picker from 'react-datepicker';
import { formatDate, toDate } from 'helpers';

function DatePicker({
  tabIndex, value, disabled, onChange, name, required = false, isClearable = true, placement = "top", portal = false, ...rest
}) {
  const uniqueClassName = `datefield-${name}`;

  const ref = useRef();
  let isDateEntering = false;

  const clearEntering = () => {
    isDateEntering = false;
  };

  const onDateSelect = (dt) => {
    clearEntering();
    onChange(formatDate(dt));
  };

  const onKeyDown = (e) => {
    e.persist();
    if (e.key !== 'Backspace') isDateEntering = true;
    // This changes was due to shift tab issue in date (11/June/2021)
    if (e.shiftKey && ref != null && ref.current != null) {
      ref.current.setOpen(false);
      clearEntering();
    }
    if (e.key === 'Enter') {
      onDateSelect(e.target.value);
    }
  };

  const onChangeDate = (date) => {
    if (!isDateEntering) {
      onChange(formatDate(date));
    }
  };

  const date = toDate(value);

  return (
    <Picker
      data-testid={name}
      onChange={onChangeDate}
      selected={date}
      ref={ref}
      tabIndex={tabIndex}
      onKeyDown={onKeyDown}
      required={required}
      isClearable={isClearable}
      // onSelect={onChangeDate}
      showYearDropdown
      disabled={disabled}
      dateFormat="dd-MMM-yyyy"
      onClickOutside={clearEntering}
      className={`${uniqueClassName}`}
      {...rest}
      popperPlacement={placement}
      portalId={`${portal ? 'root-portal' : ''}`}
    />
  );
}

export default DatePicker;
